module.exports = __webpack_public_path__ + "img/background-login2.37728fd4.png";